import {Component, Input, OnInit} from '@angular/core';
import {IDocument} from "../../interfaces/document.definition";
import {paramsHelper} from "../../helpers/params-helper";
import {E_ENDPOINTS} from "../../helpers/params/loader-params";
import {SEARCH_PROP_TYPES} from "../../enums/e-search";
import {CollectionService} from "../../services/collection.service";
import {CollectionParams} from "../../helpers/params/collection-params";
import {BusService, INewDocumentEvent} from "../../services/bus.service";
import {Subject} from "rxjs/Subject";
import {NavigationState} from "../../helpers/navigation-state";
import {SearchController} from "../../helpers/search-controller";
import {getUtcTime, processTemplateString} from "../../utils";
import {_document} from "@angular/platform-browser/src/browser";

@Component({
  selector: 'nv-profile-inapps',
  templateUrl: './nv-profile-inapps.component.html',
  styles: []
})
export class NvProfileInappsComponent implements OnInit {

  ngUnsubscribe: Subject<void> = new Subject<void>();

  private _document:IDocument;
  @Input() set document(doc:IDocument)
  {
    this._document = doc;
  }

  get document():IDocument
  {
    return this._document;
  }

  @Input() collectionParams:CollectionParams;

  inappsList:IDocument[];
  nav:NavigationState;

  constructor(private collectionService:CollectionService,
              private busService:BusService) {
    this.nav = new NavigationState(() => this.loadInappsList());
  }

  ngOnInit() {
    this.busService.onDocumentUpdated
      .takeUntil(this.ngUnsubscribe)
      .subscribe(
        e => this.onDocumentUpdated(e));
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private onDocumentUpdated(e: INewDocumentEvent) {



    if (!this.document || (e.document && this.document && this.document._id != e.document._id)) {
      this.document = e.document;
      if (this.document != null)
      {
        console.log(`inapps doc updated ${this.document._id}`);
        this.loadInappsList();
      }

    }


  }

  loadInappsList(){
    console.log('load inapps');
    const search = paramsHelper
      .search()
      .addParam("ownerId", SEARCH_PROP_TYPES.OBJECT_ID, this._document._id)
      .json;

    const params = paramsHelper.loader()
      .setEndpointId(E_ENDPOINTS.RECEIPTS)
      .setAdditionalParam("target", this.collectionParams.getTarget())
      .setNavParams(this.nav.offset, this.nav.limit)
      .setSortParams([{property:"_id", order:-1}])
      .setSearchParams(search);

    this.collectionService.loadChunk(params)
      .subscribe(result => {
        console.log(result.documents);
        this.inappsList = result.documents;
        this.nav.update(result.offset, result.count);
      });
  }

  getUtcTime(time:number):string
  {
    var utcTime:string = getUtcTime(time);
    var spaceIndex:number = utcTime.indexOf(" ");
    if (spaceIndex >= 0) {
      utcTime = utcTime.substring(spaceIndex + 1);
    }
    return utcTime;
  }

}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-profile-inapps/nv-profile-inapps.component.ts